/**
 * Complete Step - Onboarding completion summary
 */

export default function Complete({ onFinish }: { onFinish: () => void }) {
    return (
        <div className="bg-white shadow sm:rounded-lg">
            <div className="px-4 py-5 sm:p-6">
                <div className="text-center">
                    <svg
                        className="mx-auto h-12 w-12 text-[#2ba6bb]"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                    <h2 className="mt-4 text-2xl font-semibold text-gray-900">Setup Complete!</h2>
                    <p className="mt-2 text-gray-600">
                        Your organization is ready. You can now run health checks and analyze your SharePoint sites.
                    </p>
                    <p className="mt-1 text-sm text-gray-500">
                        This setup was completed once for your tenant. New team members will see this summary.
                    </p>
                </div>

                <div className="mt-8 bg-gray-50 rounded-lg p-4">
                    <h3 className="text-sm font-medium text-gray-900 mb-3">What's next:</h3>
                    <ul className="space-y-2 text-sm text-gray-600">
                        <li className="flex items-start">
                            <svg className="h-5 w-5 text-[#2ba6bb] mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path
                                    fillRule="evenodd"
                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            View health check results on your dashboard
                        </li>
                        <li className="flex items-start">
                            <svg className="h-5 w-5 text-[#2ba6bb] mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path
                                    fillRule="evenodd"
                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            Run additional scans on other sites
                        </li>
                        <li className="flex items-start">
                            <svg className="h-5 w-5 text-[#2ba6bb] mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path
                                    fillRule="evenodd"
                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            Add teammates to the SharePoint access group so they can sign in
                        </li>
                    </ul>
                </div>

                <div className="mt-6 text-center">
                    <button
                        onClick={onFinish}
                        type="button"
                        className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-[#2ba6bb] hover:bg-[#228a9d] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2ba6bb]"
                    >
                        Go to Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
}
